import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import {
    MissionService,
    BaseUserService,
    dateTimeToLocalString,
    Mission,
} from "@smarterplan/ngx-smarterplan-core";

@Component({
    selector: "app-museum-no-mission",
    templateUrl: "./museum-no-mission.component.html",
    styleUrls: ["./museum-no-mission.component.scss"],
})
export class MuseumNoMissionComponent implements OnInit {
    getMissionParamFunction = MuseumNoMissionComponent.getMissionParam;

    constructor(
        public missionService: MissionService,
        private userService: BaseUserService,
        private router: Router,
        public translate: TranslateService,
    ) { }

    ngOnInit(): void { }

    static getMissionParam(mission: Mission, translate: TranslateService) {
        const parameters = { location: "", date: "" };
        if (mission) {
            parameters.location = mission.space.name;
            parameters.date = dateTimeToLocalString(
                mission.endDateTime,
                translate,
            );
        }
        return parameters;
    }

    async logout() {
        await this.userService.logoutCurrentAndSignOutAuth();
        this.router.navigate(["connect"]);
    }
}
